interface Props {
  children: any;
}

function DownloadButtonList({ children }: Props) {
  return <div className="buttons-panel">{children}</div>;
}

export default DownloadButtonList;
